export const SET_COUNTRIES = (state, value) => {
  /* changed from Object to Array */
  state.countries = [ ...value ]
}

export const SET_RESIDENCES = (state, value) => {
  /* changed from Object to Array */
  state.residences = [ ...value ]
}

export const SET_CITIES = (state, value) => {
  state.cities = [ ...value ]
}

export const SET_TYPES = (state, value) => {
  state.types = [ ...value ]
}

export const SET_CLASSES = (state, value) => {
  state.classes = [ ...value ]
}

export const SET_UNITS = (state, value) => {
  state.units = Object.assign({}, value)
}

export const SET_TAXES = (state, value) => {
  state.taxes = Object.assign({}, value)
}

export const SET_NOTES = (state, value) => {
  state.notes = Object.assign({}, value)
}

export const SET_REASONS = (state, value) => {
  /* changed from Object to Array */
  state.reasons = [ ...value ]
}

export const SET_IVA_TYPES = (state, value) => {
  state.ivatypes = Object.assign({}, value)
}

export const SET_FORMATS = (state, value) => {
  state.billformats = Object.assign({}, value)
}

export const SET_PAYMENTS = (state, value) => {
  state.paymenttypes = [ ...value ]
}

export const SET_EXPEDIENTS = (state, value) => {
  state.expedients = [ ...value ]
}

export const SET_DFF = (state, value) => {
  state.downloadfileformats = [ ...value ]
}

export const SET_PDF_FORMATS = (state, value) => {
  state.pdfFileFormats = [...value]
}

export const SET_FILE_TYPES_OPT = (state, value) => {
  state.fileTypes = [...value]
}

export const SET_RECTIFIED_REASONS = (state, value) => {
  state.rectifiedReasons = [...value]
}

export const SET_EVENTS = (state, value) => {
  state.events = [...value]
}

export const SET_STATUS_OPTIONS = (state, value) => {
  state.statusOptions = [ ...value ]
}

export const SET_LOADED = (state, value) => {
  state.loaded = value
}

export const SET_PAYMENT_METHOD_TYPE = (state, value) => {
  state.paymentMethodType = value
}

export const SET_DOCUMENT_NATURE = (state, value) => {
  state.documentNature = value
}

export const SET_REPRESENTATION_TYPE = (state, value) => {
  state.representationType = value
}

export const SET_DOCUMENT_TYPE = (state, value) => {
  state.documentType = value
}

export const SET_REFERENCES_T = (state, value) => {
  state.referenceT = [ ...value ]
}
